
export const CollateralStyles = theme => ({
    root: {
        backgroundColor: 'white',
        border: '1px solid #6D6E6E',
        marginTop: '-10px'
    },
    cardHeader: {
        backgroundColor: '#7AA4D5',
        color: "white"
    },
    cardHeaderDisabled: {
        backgroundColor: '#b4bfcd',
        color: "white"
    },
    subHeaderPadding: {
        padding: 'px',
    },
    dashboardAlign: {
        textAlign: 'center'
    },
    dashboardIcon: {
        fontSize: '40px',
        color: '#79ba00'
    },
    dashboardIconDisabled: {
        fontSize: '40px',
        color: '#9eb17b'
    },
    searchAlign: {
        textAlign: 'right'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    table: {
        headRow: {
            style: {
                border: 'none',
            },
        },
        headCells: {
            style: {
                color: '#202124',
                fontSize: '14px',
            },
        },
        rows: {
            highlightOnHoverStyle: {
                backgroundColor: 'rgb(230, 244, 244)',
                borderBottomColor: '#FFFFFF',
                borderRadius: '25px',
                outline: '1px solid #FFFFFF',
            },
        },
        pagination: {
            style: {
                border: 'none',
            },
        }
    },
    marginNoData: {
        margin: '25px'
    },
    titles: {
        color: "black",
        fontSize: "22px",
        marginBottom: '10px',
        marginTop: '10px'
    },
    borderRadius: {
        borderRadius: '0px'
    },
    generalBorder: {
        border: '1px solid #7A9BC2',
    },
    paddingTabPanel: {
        paddingLeft: '0px',
        paddingTop: '0px',
        paddingRight: '0px'
    },
    buttonAlign: {
        textAlign: 'right'
    },
    borderLeft: {
        borderLeft: '1px solid #7A9BC2'
    },
    text:{
        color: 'black'
    },
    textDisaled:{
        color: '#afb1b3'
    },
    tableTitleAP: {
        marginTop: '0.5em',
        marginBottom: '0',
        marginLeft: '0.5em',
        fontSize: '22px',
        color: 'black'
    }
})

export const CollateralStylesEvidence = theme => ({
    root: {
        backgroundColor: 'white',
        border: '.5px solid #2F528F;'
    },
    dashboardAlign: {
        textAlign: '-webkit-center'
    },
    dashboardAlignRight: {
        textAlign: '-webkit-right'
    },
    ContainerBorder: {
        backgroundColor: '#e9ebeb73',
        border: '1px solid #c3c3c3',
        marginLeft: '50px',
    },
    ContainerOptionBorder: {
        borderRight: '.5px solid #c3c3c3'
    },
    GridBorder: {
        backgroundColor: '#E9EBEB',
        border: '.5px solid #E9EBEB',
        textAlign: 'center'
    },
    GridBorderSelected: {
        backgroundColor: '#003E5E',
        border: '.5px solid #003E5E',
        textAlign: 'center'
    },
    Text: {
        color: 'black',
        '&:hover': {
            color: '#3262C3'
        }
    },
    TextSelected: {
        color: '#FFFFFF'
    },
    ButtonSave: {
        backgroundColor: '#4CB4E7',
        color: '#FFFFFF',
        border: '.5px solid #B1D82E;',
        '&:hover': {
            backgroundColor: '#73a204'
        }
    },
    toastSuccess: {
        background: '#82C341'
    },
    toastError: {
        background: '#BF2E2E'
    },
    titleTable: {
        textAlign: 'center',
        marginTop: '30px',
        marginBottom: '30px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    table: {
        title: {
            style: {
                textAlign: 'center',
                color: 'red'
            }
        },
        headRow: {
            style: {
                border: 'none',
            },
        },
        headCells: {
            style: {
                color: '#202124',
                fontSize: '14px',
            },
        },
        rows: {
            highlightOnHoverStyle: {
                backgroundColor: 'rgb(230, 244, 244)',
                borderBottomColor: '#FFFFFF',
                borderRadius: '25px',
                outline: '1px solid #FFFFFF',
            },
        },
        pagination: {
            style: {
                border: 'none',
            },
        }
    }
})

export const CollateralStylesInvoice = theme => ({
    root: {
        backgroundColor: 'white',
        border: '.5px solid #2F528F;'
    },
    dashboardAlign: {
        textAlign: '-webkit-center'
    },
    ButtonDelete: {
        color: '#C22727'
    },
    ContainerBorder: {
        backgroundColor: '#e9ebeb73',
        border: '1px solid #c3c3c3',
        marginLeft: '50px',
    },
    ContainerOptionBorder: {
        borderRight: '.5px solid #c3c3c3'
    },
    GridBorder: {
        backgroundColor: '#E9EBEB',
        border: '.5px solid #E9EBEB;',
        textAlign: 'center'
    },
    GridBorderSelected: {
        backgroundColor: '#003E5E',
        border: '.5px solid #003E5E',
        textAlign: 'center'
    },
    Text: {
        color: 'black',
        '&:hover': {
            color: '#3262C3'
        }
    },
    TextSelected: {
        color: '#FFFFFF'
    },
    ButtonSave: {
        backgroundColor: '#4CB4E7',
        color: '#FFFFFF',
        border: '.5px solid #B1D82E;',
        '&:hover': {
            backgroundColor: '#73a204'
        }
    },
    toastSuccess: {
        background: '#82C341'
    },
    toastError: {
        background: '#BF2E2E'
    },
    titleTable: {
        textAlign: 'center',
        marginTop: '30px',
        marginBottom: '30px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    table: {
        title: {
            style: {
                textAlign: 'center',
                color: 'red'
            }
        },
        headRow: {
            style: {
                border: 'none',
            },
        },
        headCells: {
            style: {
                color: '#202124',
                fontSize: '14px',
            },
        },
        rows: {
            highlightOnHoverStyle: {
                backgroundColor: 'rgb(230, 244, 244)',
                borderBottomColor: '#FFFFFF',
                borderRadius: '25px',
                outline: '1px solid #FFFFFF',
            },
        },
        pagination: {
            style: {
                border: 'none',
            },
        }
    }
})

export const CollateralStylesComplement = theme => ({
    root: {
        backgroundColor: 'white',
        border: '.5px solid #2F528F;'
    },
    dashboardAlign: {
        textAlign: '-webkit-center'
    },
    ContainerBorder: {
        backgroundColor: '#e9ebeb73',
        border: '1px solid #c3c3c3',
        marginLeft: '50px',
    },
    ContainerOptionBorder: {
        borderRight: '.5px solid #c3c3c3'
    },
    GridBorderSelected: {
        backgroundColor: '#003E5E',
        border: '.5px solid #003E5E',
        textAlign: 'center'
    },
    Text: {
        color: 'black',
        '&:hover': {
            color: '#3262C3'
        }
    },
    TextSelected: {
        color: '#FFFFFF'
    },
    ButtonSave: {
        backgroundColor: '#84BD00',
        color: '#FFFFFF',
        border: '.5px solid #B1D82E;',
        '&:hover': {
            backgroundColor: '#73a204'
        }
    },
    toastSuccess: {
        background: '#82C341'
    },
    toastError: {
        background: '#BF2E2E'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    }
})

export const CollateralDetails = theme => ({

})